import {ExtendedNonNullableFormBuilder} from '@aviary/forms/extensions/extended-non-nullable-form-builder/extended-non-nullable-form-builder';
import {inject, Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ExtendedFormBuilder {

  public extendedNonNullableFormBuilder: ExtendedNonNullableFormBuilder = inject(ExtendedNonNullableFormBuilder);

  // Under the assumption that we'll always use nonNullable form builders, this is the only part of the original FormBuilder class that we'll replicate for now.
  public get nonNullable(): ExtendedNonNullableFormBuilder {
    return this.extendedNonNullableFormBuilder;
  }
}
